export default "__VITE_ASSET__DSj07Su4__"